import * as Yup from 'yup'
import { DefaultFormValue, JournalTypeTypes, SecurityCodeTypeTypes } from '../../containers/PositionJournals/types'

export const positionJournalSchema = (defaultValues: DefaultFormValue) =>
  Yup.object({
    journalType: Yup.mixed<JournalTypeTypes>().default('REWARD').oneOf(['REWARD'], 'Required'),
    fromAccount: Yup.string().required('Required').default(defaultValues.accountNumber),
    toAccount: Yup.string()
      .required('Required')
      .max(20, 'Maximum 20 characters')
      .matches(/^$|[A-Za-z0-9]{3}[0-9]{5}/, 'Invalid account number')
      .default(''),
    securityCodeType: Yup.mixed<SecurityCodeTypeTypes>()
      .default('TICKER_SYMBOL')
      .oneOf(['TICKER_SYMBOL', 'CUSIP', 'OCC_SYMBOL'], 'Required'),
    securityId: Yup.string()
      .required('Required')
      .when('securityCodeType', {
        is: 'TICKER_SYMBOL',
        then: Yup.string().max(7, 'Maximum characters exceeded')
      })
      .when('securityCodeType', {
        is: 'CUSIP',
        then: Yup.string().max(9, 'Maximum characters exceeded')
      })
      .when('securityCodeType', {
        is: 'OCC_SYMBOL',
        then: Yup.string().max(21, 'Maximum characters exceeded')
      })
      .default(''),
    quantity: Yup.number()
      .required('Required')
      .nullable()
      .default(null)
      .when('securityCodeType', {
        is: 'OCC_SYMBOL',
        then: Yup.number()
          .min(1, 'Amount must be greater than or equal to 1')
          .test('whole number', 'Must be a whole number', (value) => {
            if (value) {
              return !value.toString().includes('.')
            }
            return true
          })
          .test('character length', 'Maximum 12 characters', (value) => {
            if (value) {
              return value.toString().length <= 12
            }
            return false
          })
          .nullable()
          .default(null)
      })
      .when('securityCodeType', {
        is: (value: string) => {
          return value === 'CUSIP' || value === 'TICKER_SYMBOL'
        },
        then: Yup.number()
          .min(0.00001, 'Must be greater than or equal to 0.00001')
          .test('whole numbers', 'Maximum 12 whole numbers', (value) => {
            if (value) {
              const wholeNumbers = value.toString().split('.')[0]
              return wholeNumbers.length <= 12
            }
            return false
          })
          .test('decimal numbers', 'Maximum 5 decimal numbers', (value) => {
            if (value && value > 0.00001) {
              const decimalNumbers = value.toString().split('.')[1]
              if (decimalNumbers) {
                return decimalNumbers.length <= 5
              }
            }
            return true
          })
          .nullable()
          .default(null)
      }),
    quantityDisplay: Yup.string().default(''),
    amount: Yup.number()
      .test('whole numbers', 'Maximum 8 whole numbers', (value) => {
        if (value) {
          const wholeNumbers = value.toString().split('.')[0]
          return wholeNumbers.length <= 8
        }
        return true
      })
      .test('decimal numbers', 'Maximum 8 decimal numbers', (value) => {
        if (value) {
          const decimalNumbers = value.toString().split('.')[1]
          if (decimalNumbers) {
            return decimalNumbers.length <= 8
          }
        }
        return true
      })
      .nullable()
      .default(0),
    amountDisplay: Yup.string().default(''),
    sourceAccountDescription: Yup.string()
      .matches(/^$|[A-Za-z0-9 !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]+$/, 'Invalid character')
      .max(30, 'Maximum 30 characters')
      .default(''),
    sourceAccountDescription2: Yup.string()
      .matches(/^$|[A-Za-z0-9 !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]+$/, 'Invalid character')
      .max(30, 'Maximum 30 characters')
      .default(''),
    destinationAccountDescription: Yup.string()
      .matches(/^$|[A-Za-z0-9 !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]+$/, 'Invalid character')
      .max(30, 'Maximum 30 characters')
      .default(''),
    destinationAccountDescription2: Yup.string()
      .matches(/^$|[A-Za-z0-9 !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]+$/, 'Invalid character')
      .max(30, 'Maximum 30 characters')
      .default('')
  })
